import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../Style.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const Register = () => {
 
  const url = process.env.REACT_APP_BACKEND_URL 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${url}/auth/signin`, {
        name,
        email,
        password,
      });
      // console.log(response);
      toast.success("Registration successful! Please Login");
      setLoading(false);
      navigate("/");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 auth-bg">
      <div
        className="card px-4  shadow-lg w-100"
        style={{
          maxWidth: "400px",
          borderRadius: "15px",
          backgroundColor: "#fff",
          color: "#333",
        }}
      >
        <div className="text-center mb-2">
          <h3 className="mt-3" style={{ fontWeight: "600" }}>
            Register{" "}
          </h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              <i
                className="bi bi-person-fill me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Name
            </label>
            <input
              type="text"
              className="form-control shadow-sm"
              id="name"
              name="name"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              <i
                className="bi bi-envelope-fill me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Email
            </label>
            <input
              type="email"
              className="form-control shadow-sm"
              id="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              <i
                className="bi bi-lock-fill me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Password
            </label>
            <input
              type="password"
              className="form-control shadow-sm"
              id="password"
              name="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">
              <i
                className="bi bi-check2-circle me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Confirm Password
            </label>
            <input
              type="password"
              className="form-control shadow-sm"
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>

          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary btn-lg shadow-sm w-100"
              disabled={loading}
              aria-disabled={loading}
              style={{
                borderRadius: "25px",
                backgroundColor: "#2a5298",
                border: "none",
              }}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <p
              className="pe-1"
              style={{ fontSize: "0.9rem", color: "#6c757d" }}
            >
              Already have an account?
            </p>
            <Link
              to="/"
              style={{
                fontSize: "0.9rem",
                fontWeight: "600",
                textDecoration: "none",
                color: "#2a5298",
              }}
            >
              Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
